export const version = '3.0.0-rc.19';